module.exports = __webpack_public_path__ + "img/founders_4.b8a5d317.jpg";